import log from './log';

export default function registerDirectives(app) {
  app.directive('log', log);
}
